
<div class="col-md-12">
    <!-- <div class="card-header align-items-center border-0 mt-4">
<dx-toolbar>   
    <dxi-item location="before" 
              widget="dxButton"                         
              [options]="addButtonOptions">
    </dxi-item>   
</dx-toolbar>
    </div> -->
    <div style="margin-top: 0px !important;    background-color: white;" class="card-header align-items-center border-0 mt-4">

    <nav class="toolbar toolbar-icon align-content-center">
        <div class="rounded-pill d-flex align-items-center">
          <a type="button" class="btn btn-hover" routerLink="/dashboard">
            <i class="me-1 sidebar-text fa-solid fa-arrow-left"></i>
            <span class="types-custom__letter">Atrás</span>
          </a>
  
          <a type="button" class="btn btn-hover" [routerLink]="['/microapplication-settings']">
            <i class="me-1 sidebar-text fa-solid fa-plus" ></i>
            <span class="types-custom__letter">Nuevo</span>
          </a>

          <a style="cursor: pointer;" type="button" class="btn btn-hover" >
            <i style="cursor: pointer;" class="me-1 sidebar-text dx-icon-movetofolder"
               (click)="import()" > 
               <span class="types-custom__letter" style="font-size: large;">{{ txtImportar }}</span></i>
          </a>
  
          <!-- <dx-toolbar>
            <dxi-item
              location="before"
              widget="dxButton"
              [options]="addButtonOptions"
            >
            </dxi-item>
          </dx-toolbar> -->
        </div>
    </nav>
</div>
 <div class="scrollable-div  col-md-13">
    <!-- <div class="long-title">
        <h3>Microaplicaciones</h3>
      </div> -->
        <div id ="divMicroAppsGridA">
            <dx-data-grid id="gridContainer" 
            [noDataText]="'Sin microaplicaciones'" 
             [columnHidingEnabled]= "false" 
             [dataSource]="microApps.microappsData | async" 
             (onRowDblClick)="onRowDblClick($event)"
            (onRowDblClick)="onRowDblClick($event)"
            [columnAutoWidth]="true"
            [showColumnLines]="true" [showColumnHeaders]="true" [showRowLines]="true" [showBorders]="true"
            [rowAlternationEnabled]="true"
            [height]='gridHeight'
            >
            <dxo-load-panel [enabled]="true">
            </dxo-load-panel>
            <dxo-export [enabled]="true" fileName="Microaplicaciones" [allowExportSelectedData]="true"></dxo-export>
            <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true" [placeholder]="'Buscar'">
            </dxo-search-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true">
            </dxo-pager>
            <dxi-column  alignment="center" dataField="icon" caption="ícono" cellTemplate="iconTemplate">
            </dxi-column>
            <div *dxTemplate="let icon of 'iconTemplate'">
                <span class="icon-grid">
                    <i [class]="icon.value"></i>
                </span>
            </div>
            <dxi-column dataField="code" caption="Código"></dxi-column>
            <dxi-column dataField="name.esCO" caption="Nombre"></dxi-column>
            <dxi-column dataField="type" caption="Tipo"></dxi-column>
            <dxi-column dataField="description.esCO" caption="Descripción"></dxi-column>
            <dxi-column dataField="category" caption="Categoría"></dxi-column>
            <dxi-column type="buttons" [width]="100">
                <dxi-button [name]="'editar'" [icon]="'dx-icon-edit pointer'" [visible]="true" [onClick]="editMicroAppclick" ></dxi-button>
                <dxi-button [name]="'borrar'" [icon]="'dx-icon-trash pointer'" [visible]="false" ></dxi-button>
            </dxi-column>
            <div *dxTemplate="let data of 'totalGroupCount'">
                <div class="informer">
                    <h2 class="count">Lista de microaplicaciones</h2>                
                </div>
            </div>
            
        </dx-data-grid>
    
        
        </div>
        <!-- <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#divMicroAppsGrid' }"
        [(visible)]="microApps.loading" [showIndicator]="true" [showPane]="true" [shading]="true"
        [message]="'Cargando...'" [closeOnOutsideClick]="false">
    </dx-load-panel> -->
    
 </div>
</div>

<input #jsonImportButton style="display: none;" (change)="changeFileJSONButton($event)" type='file'
    id="JsonfileImportButton" accept=".json" />

